<template>
  <div>
    <h1>Aufbau und Funktionen - Quiz</h1>

    <div
      id="carouselExampleIndicators"
      class="carousel slide"
      data-ride="carousel"
      data-interval="false"
    >
      <ol class="carousel-indicators">
        <li
          data-target="#carouselExampleIndicators"
          data-slide-to="0"
          class="active"
        ></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="5"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="6"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="7"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="8"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="9"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="10"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="11"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="12"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="13"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="14"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="15"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="16"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="17"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="18"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="19"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="20"></li>
        <!-- <li data-target="#carouselExampleIndicators" data-slide-to="21"></li> -->

      </ol>
      <div class="carousel-inner">
        <div class="carousel-item active">
          <!-- <img class="d-block w-100" src="@/assets/spec-analyse-abl.jpg" alt="First slide"> -->
          <h2>
            Übungsteil zum Aufbau und zur Funktion der Bauteile des menschlichen
            Ohrs
          </h2>
          <p>
            Hier werden euch diverse Übungsaufgaben erwarten, probiert es
            einfach mit einem Klick auf den rechten Pfeil aus!
          </p>
        </div>
        <div class="carousel-item">
          <div>
            <h2>
              Beschrifte die Bestandteile des Außenohrs.
            </h2>
            <img src="@/assets/Uebersicht_Ohr_Außen.jpg" style="width: 60%;">
            <Aufbau_DnD id="lists4" ref="testcomponent"/>
            <button id="button1" v-on:click="evaluate">Prüfen</button>
          </div>
        </div>
        <div class="carousel-item">
          <Aufbau_MC v-if="this.$store.state.aufbauDnD_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Aufbau_MC2 v-if="this.$store.state.aufbauMC_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Aufbau_MC3 v-if="this.$store.state.aufbauMC2_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Aufbau_MC4 v-if="this.$store.state.aufbauMC3_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Aufbau_Form2 v-if="this.$store.state.aufbauMC4_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <div v-if="this.$store.state.aufbauForm2_done">
            <h2>
              Beschrifte die Bestandteile des Mittelohrs.
            </h2>
            <img src="@/assets/Uebersicht_Ohr_Mittel.jpg" style="width: 60%;">
            <Aufbau_DnD2 id="lists7" ref="testcomponent2"/>
            <button id="button3" v-on:click="evaluate2">Prüfen</button>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>









        <div class="carousel-item">
          <Aufbau_MC5 v-if="this.$store.state.aufbauDnD2_done"/> 
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Aufbau_MC6 v-if="this.$store.state.aufbauMC5_done"/> 
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Aufbau_MC7 v-if="this.$store.state.aufbauMC6_done"/> 
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Aufbau_Form3 v-if="this.$store.state.aufbauMC7_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <div v-if="this.$store.state.aufbauForm3_done">
            <h2>
              Beschrifte die Bestandteile des Innenohrs.
            </h2>
            <img src="@/assets/Uebersicht_Ohr_Innen.jpg" style="width: 60%;">
            <Aufbau_DnD3 id="lists8" ref="testcomponent3"/>
            <button id="button4" v-on:click="evaluate3">Prüfen</button>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>





        <div class="carousel-item">
          <Aufbau_MC8 v-if="this.$store.state.aufbauDnD3_done"/> 
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Aufbau_MC9 v-if="this.$store.state.aufbauMC8_done"/> 
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Aufbau_MC10 v-if="this.$store.state.aufbauMC9_done"/> 
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Aufbau_Form4 v-if="this.$store.state.aufbauMC10_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>



        <!-- <div class="carousel-item">
          <div id="DnD" v-if="this.$store.state.aufbauMC5_done">
            <div class="flexbox">
              <div>
                <img id="hintergrund" src="@/assets/oreille-externe_750.jpg" />
                <Aufbau_DnD id="lists" ref="testcomponent" />
                <button id="button1" v-on:click="evaluate">Prüfen</button>
              </div>
            </div>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div> -->
        <!-- <div class="carousel-item">
          <Aufbau_Form v-if="this.$store.state.aufbauForm4_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div> -->
        <div class="carousel-item">
          <div v-if="this.$store.state.aufbauForm4_done">
            <h2>Typische Klausuraufgaben I</h2>
            <br>
            <h4>1. Skizzieren Sie schemenhaft den anatomischen Aufbau des menschlichen Ohrs und beschriften Sie die Hauptbestandteile (mindestens 7, insg. 10 Pkt.).</h4>
            <br> <br>
            <p>Wir würden vorschlagen, das ganze erst einmal selbst zu versuchen. Auf dem nächsten Slide befindet sich aber noch eine Beispielskizze zum selbst beschriften und einen kompletten Lösungsvorschlag.</p>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Aufbau_KL v-if="this.$store.state.aufbauForm4_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <div v-if="this.$store.state.aufbauForm4_done">
            <h2>Typische Klausuraufgaben II</h2>
            <br>
            <h4>2. Nennen Sie die Bestandteile des Vestibularapparates (Gleichgewichtsorgan) im Innenohr (2 Pkt.). 
            Beschreiben Sie stichpunktartig deren Funktion (8 Pkt.).
            </h4>
            <br> <br>
            <p>Auch hier empfiehlt es sich, das ganze erst einmal selbst auszuprobieren. Eine mögliche Beispiellösung wird auf dem nächsten Slide angezeigt. </p>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <div v-if="this.$store.state.aufbauForm4_done">
            <h2>Typische Klausuraufgaben II - Lösung</h2>
            <br>
            <h4>2. Nennen Sie die Bestandteile des Vestibularapparates (Gleichgewichtsorgan) im Innenohr (2 Pkt.). 
              Beschreiben Sie stichpunktartig deren Funktion (8 Pkt.).
            </h4>
            <br> 
            <div align = "left">
              <h5>Nennung:</h5>
              <ul>
                <li>3 Bogengänge (1 Pkt.)</li>
                <li>Sacculus (0,5 Pkt.)</li>
                <li>Utriculus (0,5 Pkt.)</li>
              </ul>
              <h5>Beschreibung:</h5>
              <p>Bogengänge (max. 4 Pkt.)</p>
              <ul>
                <li>3 verschiedene, senkrecht (oder 90 Grad oder orthogonal) zueinander angeordnete</li>
                <li>endolymphgefüllte Gänge</li>
                <li>erfassen Drehbewegung</li>
                <li>Gallertkegel wird bei Drehung (durch strömende Endolymphe) gebogen</li>
                <li>Haarsinneszellen werden dadurch abgeschert und geben Impuls weiter (Aktionspotentiale)</li>
              </ul>
              <p>Sacculus und Utriculus (max. 4 Pkt.)</p>
              <ul>
                <li>stehen ebenfalls senkrecht zueinander</li>
                <li>erfassen translatorischer Beschleunigung</li>
                <li>Sinneszellen ragen in gallertartige Membran, die mit</li>
                <li>Kalkkristallen besetzt ist (Trägheit)</li>
                <li>durch träge Verschiebung der Membran, Erzeugung von</li>
                <li>Aktionspotentialen an den Sinneszellen</li>
              </ul>
            </div>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>


        </div>


          


      </div>
      <a
        class="carousel-control-prev"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="prev"
      >
        <span id ="test" class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a
        class="carousel-control-next"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</template>

<script>
// import Aufbau_DnD from "../DnD_components/Aufbau_DnD.vue";
import Aufbau_DnD from "../DnD_components/Aufbau_DnD.vue";
import Aufbau_DnD2 from "../DnD_components/Aufbau_DnD2.vue";
import Aufbau_DnD3 from "../DnD_components/Aufbau_DnD3.vue";
import Aufbau_MC from "../MC_components/Aufbau_MC.vue";
// import Aufbau_Form from "../Form_Components/Aufbau_Form.vue";
import Aufbau_Form2 from "../Form_Components/Aufbau_Form2.vue";
import Aufbau_Form3 from "../Form_Components/Aufbau_Form3.vue";
import Aufbau_Form4 from "../Form_Components/Aufbau_Form4.vue";
import Aufbau_KL from "../Form_Components/Aufbau_KL.vue"
import Aufbau_MC2 from "../MC_components/Aufbau_MC2.vue"
import Aufbau_MC3 from "../MC_components/Aufbau_MC3.vue"
import Aufbau_MC4 from "../MC_components/Aufbau_MC4.vue"
import Aufbau_MC5 from "../MC_components/Aufbau_MC5.vue"
import Aufbau_MC6 from "../MC_components/Aufbau_MC6.vue"
import Aufbau_MC7 from "../MC_components/Aufbau_MC7.vue"
import Aufbau_MC8 from "../MC_components/Aufbau_MC8.vue"
import Aufbau_MC9 from "../MC_components/Aufbau_MC9.vue"
import Aufbau_MC10 from "../MC_components/Aufbau_MC10.vue"

export default {
  name: "DnD",
  components: {
    // Aufbau_DnD,
    Aufbau_DnD,
    Aufbau_DnD2,
    Aufbau_DnD3,
    Aufbau_MC,
    Aufbau_MC2,
    Aufbau_MC3,
    Aufbau_MC4,
    Aufbau_MC5,
    Aufbau_MC6,
    Aufbau_MC7,
    Aufbau_MC8,
    Aufbau_MC9,
    Aufbau_MC10,
    Aufbau_Form2,
    Aufbau_Form3,
    Aufbau_Form4,
    Aufbau_KL
  },
  methods: {
    evaluate: function (event) {
      if (event) {
        this.$refs.testcomponent.test();
      }
    },
    evaluate2: function (event) {
      if (event) {
        this.$refs.testcomponent2.test();
      }
    },
    evaluate3: function (event) {
      if (event) {
        this.$refs.testcomponent3.test();
      }
    },
  },
};
</script>

<style>
#hintergrund {
  /* position: absolute; */
  left: 300px;
}
#button1, #button2 {
  position: absolute;
  left: 650px;
  top: 550px;
  font-family: sans-serif;
  font-size: 20px;
  /* background-color: #297; */
  color: #fff;
  border: 0px;
  border-radius: 3px;
  padding: 20px;
  cursor: pointer;
  margin-bottom: 20px;
  background-color: #528382
}
#DnD {
  height: 800px;
}

/* Styles für das Drag/Drop  */
.flexbox {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 800px;
  /* height: 500px; */
  overflow: hidden;
  margin: 0 auto;
  padding: 15px;
}
</style> 
